import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageEventServiceService {
  private key = 'jsipPanelSelectedProductDetails';

  private subject = new BehaviorSubject<any>(this.read());
  selectedProduct$ = this.subject.asObservable();

   private subjectSubMenuCurrentSection = new BehaviorSubject<any>(this.readSubMenuCurrentSection());
  subMenuCurrentSection$ = this.subjectSubMenuCurrentSection.asObservable();

   private subjectSubMenuSelectedParentLabel = new BehaviorSubject<any>(this.readSubMenuSelectedParentLabel());
  subMenuSelectedParentLabel$ = this.subjectSubMenuSelectedParentLabel.asObservable();

  setSelectedProduct(value: any) {
    localStorage.setItem(this.key, JSON.stringify(value));
    this.subject.next(value);
  }

  private read(): any {
    const raw = localStorage.getItem(this.key);
    return raw ? JSON.parse(raw) : null;
  }

  setSubMenuCurrentSection(value){
     localStorage.setItem("currentSection", value);
     this.subjectSubMenuCurrentSection.next(value);
  }
  setSubMenuSelectedParentLabel(value){
     localStorage.setItem("selectedParentLabel", value);
      this.subjectSubMenuSelectedParentLabel.next(value);
  }

  private readSubMenuCurrentSection(){
 const raw = localStorage.getItem('currentSection');
    return raw ? raw : null;
  }
  private readSubMenuSelectedParentLabel(){
     const raw = localStorage.getItem('selectedParentLabel');
    return raw ? raw : null;
  }
}
